export default __webpack_public_path__ + "static/media/resumeBuilder.86936483.PNG";